import { render } from "./Divider.vue?vue&type=template&id=2b27538a&scoped=true"
import script from "./Divider.vue?vue&type=script&lang=js"
export * from "./Divider.vue?vue&type=script&lang=js"

import "./Divider.vue?vue&type=style&index=0&id=2b27538a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b27538a"]])

export default __exports__